export const CP_GAMIFICATION = "qa.gamification.bpower2.com";
export const HOPPY = "hoppy.com.pl";
// export const HOPPY = "localhost";
export const ARI = "audyt.aridotacje.pl";
export const BP2_CLOUD = "bp2.cloud";
export const BP2_CLOUD_QA = "qa.bp2.cloud";
export const CZG = "czg.bp2.cloud";
export const CZG_QA = "qa-czg.bp2.cloud";
export const APLOG = "ap.log.bp2.cloud";
export const MULTIMODUS = "multimodus.bp2.cloud";
export const MULTIMODUS_QA = "multimodus-qa.bp2.cloud";
export const PFLEGEPOWER = "pflegepower.com";
export const ETRACON = "login.e-tracon.com";
export const AMLSEC = "localhost";
export const HOMEDEAL = "home-deal";
export const GABINET = "gabinet";
